import i18n from 'utils/i18n'
import { privacyOptions } from 'utils/constants/settings-constants'

export const privacyOptionsSelect = [
	{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_phonenumber.values.no') },
	{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_phonenumber.values.team') },
	{ value: privacyOptions.EVERYBODY, label: i18n.t( 'form.fields.show_phonenumber.values.company') }
]
